import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { color } from '../styles/helpers/variables';
import { shadowOnHover } from '../styles/helpers/mixins';
import { Heading } from '../styles/Heading';
import { Preamble } from '../styles/Preamble';
import { ProductTag } from '../styles/ProductTag';

const CampaignListItem = props => {
  if (!props.title || !props.image) {
    return false;
  }
  
  if (!props.to) {
    return (
      <CampaignListItemContainerBase>
        <CampaignListItemImageContainer>
          <CampaignListItemImage image={props.image}>
            <ProductTag absolute color={color.primary} spacing="12px" minFontSize={12}>
              Kampanj
            </ProductTag>
          </CampaignListItemImage>
        </CampaignListItemImageContainer>
        <CampaignListItemContent>
          <div>
            <CampaignListItemHeading>{props.title}</CampaignListItemHeading>
            <CampaignListItemHPreamble textAlign="left">{props.preamble}</CampaignListItemHPreamble>
            <CampaignListItemSmallPrint>
              Erbjudandet gäller under en begränsad period och kan inte kombineras med andra erbjudanden.
            </CampaignListItemSmallPrint>
          </div>
        </CampaignListItemContent>
      </CampaignListItemContainerBase>
    );
  }

  return (
    <CampaignListItemContainer to={props.to}>
      <CampaignListItemImageContainer>
        <CampaignListItemImage image={props.image}>
          <ProductTag absolute color={color.primary} spacing="12px" minFontSize={12}>
            Kampanj
          </ProductTag>
        </CampaignListItemImage>
      </CampaignListItemImageContainer>
      <CampaignListItemContent>
        <div>
          <CampaignListItemHeading>{props.title}</CampaignListItemHeading>
          <CampaignListItemHPreamble textAlign="left">{props.preamble}</CampaignListItemHPreamble>
          <CampaignListItemSmallPrint>
            Erbjudandet gäller under en begränsad period och kan inte kombineras med andra erbjudanden.
          </CampaignListItemSmallPrint>
        </div>
        <CampaignListItemLinkText>{props.linkTitle}</CampaignListItemLinkText>
      </CampaignListItemContent>
    </CampaignListItemContainer>
  );
};

const CampaignListItemContainerBase = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 27px;
  text-decoration: none;
  color: ${color.black};

  @media screen and (min-width: 1000px) {
    margin-bottom: 25px;
    flex-direction: row;
    align-items: stretch;
  }
`;

const CampaignListItemContainer = styled(Link)`
  ${shadowOnHover};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 27px;
  text-decoration: none;
  color: ${color.black};

  @media screen and (min-width: 1000px) {
    margin-bottom: 25px;
    flex-direction: row;
    align-items: stretch;
  }
`;

const CampaignListItemImageContainer = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;

  @media screen and (min-width: 1000px) {
    width: 365px;
    height: auto;
    padding-bottom: 0;
  }
`;

const CampaignListItemImage = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: url("${props => props.image}");
  background-position: center;
  background-size: cover;
`;

const CampaignListItemContent = styled.div`
  flex: 1;
  background-color: ${color.white};
  padding: 28px 25px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  @media screen and (min-width: 1000px) {
    padding: 60px 72px 50px 72px;
    min-height: 365px;
  }
`;

const CampaignListItemHeading = Heading.p.extend`
  font-size: 18px !important;
  
  @media screen and (min-width: 1000px) {
    font-size: 26px !important;
  }
`;

const CampaignListItemHPreamble = Preamble.extend`
  font-size: 15px !important;

  @media screen and (min-width: 1000px) {
    font-size: 20px !important;
  }
`;

const CampaignListItemSmallPrint = styled.p`
  font-size: 12px;
  font-weight: normal;
  font-style: italic;
  font-stretch: normal;
  line-height: 1.83;
  letter-spacing: normal;
  color: ${color.black};
  margin: 20px 0 8px;

  @media screen and (min-width: 1000px) {
    margin: initial;
  }
`;

const CampaignListItemLinkText = styled.p`
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: ${color.black};

  @media not all and (hover: none) {
    margin: 2em 0 1em;
    padding: 10px 0;
    position: relative;

    &:before,
    &:after {
      content: '';
      position: absolute;
      right: 0;
      left: 0;
      height: 1px;
      display: block;
      opacity: 0;
      transition: opacity 250ms ease-out, transform 250ms ease-out;
      background-color: ${color.black};
    }

    &:before {
      bottom: -5px;
      transform: translateY(10px);
    }

    &:after {
      top: -5px;
      transform: translateY(-10px);
    }

    ${CampaignListItemContainer}:hover & {
      &:before,
      &:after {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }
`;

CampaignListItem.defaultProps = {
  to: null,
  title: null,
  preamble: null,
  image: null,
  linkTitle: null
};

CampaignListItem.propTypes = {
  to: PropTypes.string,
  title: PropTypes.string,
  preamble: PropTypes.string,
  image: PropTypes.string,
  linkTitle: PropTypes.string
};

export default CampaignListItem;



// WEBPACK FOOTER //
// ./src/components/CampaignListItem.js